import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BackgroundEffects from './components/BackgroundEffects';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <div className="relative min-h-screen bg-black overflow-x-hidden">
        <Navbar />
        <BackgroundEffects />

        <main>
          <Hero />
          <About />
          <Services />
          <Pricing />
          <Contact />
          <Footer />
        </main>
      </div>
    </LanguageProvider>
  );
}

export default App;
